module.exports = __webpack_public_path__ + "static/media/Essetional2.52f53708.svg";